import { create } from "zustand";

export interface ConfirmOptions {
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	variant?: "danger" | "warning" | "info";
}

interface ConfirmStore {
	isOpen: boolean;
	options: ConfirmOptions | null;
	resolver: ((value: boolean) => void) | null;
	open: (options: ConfirmOptions) => Promise<boolean>;
	handleConfirm: () => void;
	handleCancel: () => void;
}

export const useConfirmStore = create<ConfirmStore>((set, get) => ({
	isOpen: false,
	options: null,
	resolver: null,
	open: (options) =>
		new Promise<boolean>((resolve) => {
			set({ isOpen: true, options, resolver: resolve });
		}),
	handleConfirm: () => {
		get().resolver?.(true);
		set({ isOpen: false, options: null, resolver: null });
	},
	handleCancel: () => {
		get().resolver?.(false);
		set({ isOpen: false, options: null, resolver: null });
	},
}));

export const confirm = (options: ConfirmOptions) =>
	useConfirmStore.getState().open(options);
